import React from 'react'
import './infoAdicional.css'
import { WhatsButton } from '../../components';
// vê se tem como melhorar/otimizar o esquema do efeito do fundo desse aqui
const InfoAdicional = () => {
  return (
    <div className="psico__infoAdicional">
      <div className="psico__infoAdicional-content">
        <p><b>Seu primeiro passo para transformar sua vida está aqui!</b></p><br />
        {/* <p>Está pronto?</p> */}
      </div>
      <div className="psico__infoAdicional-add">
        {/* <p>Aproveite o Valor Promocional (Vagas limitadas) - <a href="#infos"><u>Veja o valor nas Informações.</u></a></p><br /> */}
        {/* <p>Encare seus desafios com confiança e construa o bem-estar que você merece.</p>
        <p>A decisão está nas suas mãos – comece hoje mesmo!</p>
        <p>Está pronto para iniciar sua jornada?</p><br /> */}
        <p>Dê espaço para o que você sente. <strong>Tenha uma vida que valha a pena ser vivida!</strong></p>
      </div>
      <div className="psico__infoAdicional-button">
        <WhatsButton message="Faça a sua escolha!" />
      </div>
    </div>
  )
}

export default InfoAdicional
